import { useLocation } from "react-router-dom";
import AdSenseUnit from "./AdSenseUnit";
import { AD_SLOTS } from "../config/adSlots";

const EXCLUDED_PATHS = new Set([
  "/contact-us",
  "/advertise-with-us",
  "/privacy-policy",
  "/terms-conditions",
  "/disclaimer",
]);

const EXCLUDED_PREFIXES = [
  "/api/",
];

const isAdEligiblePath = (pathname = "") => {
  if (!pathname) return false;
  if (EXCLUDED_PATHS.has(pathname)) return false;
  return !EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

const POSITION_SLOTS = {
  top: AD_SLOTS.pageTop,
  bottom: AD_SLOTS.pageBottom,
};

const POSITION_STYLES = {
  top: { marginTop: "16px", marginBottom: "16px" },
  bottom: { marginTop: "12px", marginBottom: "28px" },
};

const PageAdPlacements = ({ position = "bottom" }) => {
  const location = useLocation();
  const pathname = location.pathname || "";

  if (!isAdEligiblePath(pathname)) {
    return null;
  }

  const slot = POSITION_SLOTS[position] || POSITION_SLOTS.bottom;
  const style = POSITION_STYLES[position] || POSITION_STYLES.bottom;

  return <AdSenseUnit slot={slot} style={style} />;
};

export default PageAdPlacements;
